<template>
  <basic-container>
    <el-form ref="form" :model="form" label-width="130px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-divider content-position="left"><strong>费项信息</strong></el-divider>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="房产" prop="propertyId">
            <el-select
              :value="propertyName"
              ref="propertyAddParentNodeSelectRef"
              placeholder="请选择房产"
              clearable
              style="width: 100%"
              :disabled="editDisable2"
            >
              <el-option :value="propertyName" :label="propertyName">
                <el-tree
                  ref="propertyAddParentNodeTreeRef"
                  node-key="id"
                  :props="treeProps"
                  :load="lazyLoadPropertyTree"
                  lazy
                  @node-click="propertyNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费项范围" prop="objectTypeName">
            <el-input v-model="form.objectTypeName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用种类" prop="feeSort">
            <el-select
              v-model="form.feeSort"
              placeholder="请选择"
              style="width: 100%"
              @change="feeSortChanged"
              :disabled="editDisable2"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in feeSortList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="种类细分" prop="sortType">
            <el-select
              v-model="form.sortType"
              placeholder="请选择"
              style="width: 100%"
              :disabled="editDisable2"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in enableSortTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="费项编码" prop="feeItemCode">
            <el-input v-model="form.feeItemCode" :disabled="editDisable2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费项名称" prop="feeItemName">
            <el-input v-model="form.feeItemName" :disabled="editDisable1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否周期收费" prop="cycleFlag">
            <el-select
              v-model="form.cycleFlag"
              style="width: 100%"
              @change="changeCycleFlag"
              :disabled="editDisable2"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in cycleFlagDictData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费周期数" prop="feeCycleNum">
            <el-input v-model.number="form.feeCycleNum" :disabled="cycleFlagBool"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费周期" prop="feeCycle">
            <el-select
              v-model="form.feeCycle"
              placeholder="请选择"
              style="width: 100%"
              @change="feeCycleChanged"
              :disabled="cycleFlagBool"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in feeCycleList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="自定义名称" prop="feeCycleName">
            <el-input v-model="form.feeCycleName" :disabled="feeCycleNameDisable"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计费方式" prop="feeType">
            <el-select
              v-model="form.feeType"
              placeholder="请选择"
              style="width: 100%"
              @change="feeTypeChanged"
              :disabled="editDisable1"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in feeTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="提前N天提醒" prop="remindDays">
            <el-input v-model.number="form.remindDays" :disabled="editDisable1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="收费开始日期" prop="billStartDate">
            <el-date-picker
              v-model="form.billStartDate"
              type="date"
              placeholder="收费开始日期"
              style="width: 100%"
              :disabled="editDisable1"
              value-format="yyyy-MM-dd 00:00:00"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启用日期" prop="useTime">
            <el-date-picker
              v-model="form.useTime"
              type="date"
              placeholder="启用日期"
              style="width: 100%"
              :disabled="editDisable1"
              value-format="yyyy-MM-dd 00:00:00"
              @change="validateForm('stopTime')"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="停用日期" prop="stopTime">
            <el-date-picker
              v-model="form.stopTime"
              type="date"
              placeholder="停用日期"
              style="width: 100%"
              :disabled="editDisable1"
              value-format="yyyy-MM-dd 00:00:00"
              @change="validateForm('useTime')"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="逾期N天催收" prop="msgDays">
            <el-input v-model.number="form.msgDays" :disabled="editDisable1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="超期天数" prop="delayDays">
            <el-input v-model.number="form.delayDays" :disabled="editDisable1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="滞纳金比率" prop="delayRate">
            <el-input
              oninput="value=value.replace(/[^\d.]/g,'')"
              v-model="form.delayRate"
              :disabled="editDisable1"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-form-item label="锁定单价">
            <el-switch
              v-model="form.lockpriceFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="短信催收">
            <el-switch
              v-model="form.msgFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="短信提醒">
            <el-switch
              v-model="form.remindFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="账户抵扣">
            <el-switch
              v-model="form.accountFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="优惠券抵扣">
            <el-switch
              v-model="form.couponFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="优惠政策">
            <el-switch
              v-model="form.preferentFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="银行划扣">
            <el-switch
              v-model="form.bankFlag"
              :active-value="switchValue.yes"
              :inactive-value="switchValue.no"
              :disabled="editDisable1"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-divider content-position="left"><strong>价格设定</strong></el-divider>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="计价类型" prop="priceSet">
            <el-radio-group v-model="form.priceSet" @change="priceSetChanged">
              <el-radio label="1" :disabled="editDisable1">按单价</el-radio>
              <el-radio label="2" :disabled="editDisable1">包干价</el-radio>
              <el-radio label="3" :disabled="gradePriceDisable">阶梯价</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="unitPriceName" prop="unitPrice">
            <el-input
              v-model="form.unitPrice"
              :disabled="gradePriceShow || editDisable1"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col></el-col>
      </el-row>
      <el-row v-for="(stepPrice, index) in form.stepPrices" :key="index" v-show="gradePriceShow">
        <el-col :span="6" offset="1">
          <el-form-item :label="'阶梯价' + (index + 1)">
            <el-input v-model="stepPrice.stepMin" disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :key="stepPrice.stepIndex"
            label="<=使用量<="
            :prop="`stepPrices[${index}].stepMax`"
            :rules="[
              { required: true, message: '请输入阶梯价格最大值', trigger: 'blur' },
              { type: 'number', message: '阶梯价格必须为数值', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model.number="stepPrice.stepMax"
              :disabled="index !== form.stepPrices.length - 1"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" offset="1">
          <el-form-item
            label="阶梯单价"
            :prop="`stepPrices[${index}].stepPrice`"
            :rules="{ required: true, message: '请输入阶梯单价', trigger: 'blur' }"
            ><el-input
              v-model="stepPrice.stepPrice"
              oninput="value=value.replace(/[^\d.]/g,'')"
              :disabled="editDisable1"
          /></el-form-item>
        </el-col>
        <el-col :span="2" offset="1" v-show="index === form.stepPrices.length - 1">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click.prevent="removeStepPrice(index)"
            :hidden="editDisable1"
          /><el-button
            type="primary"
            icon="el-icon-plus"
            circle
            @click.prevent="addStepPrice(stepPrice)"
            :hidden="editDisable1"
          ></el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="偏移" prop="offsetNumFlag">
            <el-switch
              @change="offsetNumChange"
              v-model="form.offsetFlag"
              active-value="1"
              inactive-value="0"
              :disabled="editDisable2"
            >
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.offsetFlag === '1'">
          <el-form-item label="偏移量" prop="offsetMoney" :rules="[{
                    required:true,
message: '请输入偏移量', trigger: 'change'
                  }]">
            <el-input
              type="text"
              v-model="form.offsetMoney"
              :disabled="editDisable2"
              maxlength="100"
              placeholder="请输入偏移量"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="附加费项" prop="extraFlag">
            <el-switch
              @change="addtionFeeItemChange"
              v-model="form.extraFlag"
              active-value="1"
              inactive-value="0"
              :disabled="editDisable2"
            >
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="form.extraFlag === '1'">
        <el-col :span="24">
          <el-form-item label=" " prop="feeItemsetSubs"  :rules="[{
                    required:true,
message: '请添加附加费项', trigger: 'change'
                  }]">
            <el-table height="300" :data="form.feeItemsetSubs" border style="width: 100%">
              <el-table-column align="center">
                <template slot="header" slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    :disabled="editDisable2"
                    circle
                    @click="addItemHandler"
                  ></el-button>
                </template>
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-minus"
                    :disabled="editDisable2"
                    circle
                    @click="deleteItemHandler(scope)"
                  ></el-button>
                </template>
              </el-table-column>

              <el-table-column label="子费项名称">
                <template slot-scope="scope">
                  <el-form-item label-width="0" :prop="`feeItemsetSubs[${scope.$index}].sortType`" :rules="[{
                    required:true,
message: '请选择子费项名称', trigger: 'blur'
                  }]">
                    <el-select
                      :disabled="editDisable2"
                      v-model="scope.row.sortType"
                      size="mini"
                      placeholder="请选择子费项名称"
                    >
                      <el-option
                        style="padding-left: 10px"
                        v-for="item in enableSortTypeAddtionList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                </template>
              </el-table-column>

              <el-table-column label="计费方式">
                <template slot-scope="scope">
                  <el-form-item label-width="0" :prop="`feeItemsetSubs[${scope.$index}].feeType`" :rules="[{
                    required:true,
message: '请选择计费方式', trigger: 'blur'
                  }]">
                    <el-select
                      :disabled="editDisable2"
                      v-model="scope.row.feeType"
                      size="mini"
                      placeholder="请选择计费方式"
                    >
                      <el-option
                        style="padding-left: 10px"
                        v-for="item in feeTypeList"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="计价类型" prop="date">
                <template slot-scope="scope">
                  <el-form-item label-width="0" :prop="`feeItemsetSubs[${scope.$index}].feeType`" :rules="[{
                    required:true,
message: '请选择计价类型', trigger: 'blur'
                  }]">
                  <el-select
                    :disabled="editDisable2"
                    v-model="scope.row.priceSet"
                    size="mini"
                    placeholder="请选择计价类型"
                  >
                    <el-option
                      style="padding-left: 10px"
                      v-for="item in priceSetList"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="金额" prop="date">
                <template slot-scope="scope">

                  <el-form-item label-width="0" :prop="`feeItemsetSubs[${scope.$index}].unitPrice`" :rules="[{
                    required:true,
message: '请填写金额', trigger: 'change'
                  }]">
                  <el-input
                    :disabled="editDisable2"
                    v-model="scope.row.unitPrice"
                    size="mini"
                    placeholder="请填写金额"
                  ></el-input>
                  </el-form-item>

                </template>
              </el-table-column>

              <el-table-column label="是否拆分账单" prop="date">
                <template slot-scope="scope">
                  <el-form-item label-width="0" :prop="`feeItemsetSubs[${scope.$index}].splitFlag`" :rules="[{
                    required:true,
message: '请选择是否拆分账单', trigger: 'blur'
                  }]">
                  <el-select
                    :disabled="editDisable2"
                    v-model="scope.row.splitFlag"
                    size="mini"
                    placeholder="请选择是否拆分账单"
                  >
                    <el-option
                      style="padding-left: 10px"
                      v-for="item in billSplitList"
                      :key="item.dictKey"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注信息" prop="remark1">
            <el-input
              type="textarea"
              v-model="form.remark1"
              :disabled="editDisable1"
              maxlength="100"
              rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="text-align: center">
        <el-button type="primary" @click="onSubmit" style="width: 72px" :hidden="editDisable1"
          >确认</el-button
        >
        <el-button @click="closeDia('unRefresh')" style="width: 72px" :hidden="editDisable1"
          >取消</el-button
        >
      </el-row>
    </el-form>
  </basic-container>
</template>
<script>
import _ from 'lodash';
import {
  add,
  getDetail,
  getLabelName,
  getPropertyTreeByObjectTypeKey,
} from '@/api/v4ward/itemset/feeitemset';
import { getDictionaryWithIntKey } from '../../../api/common';
import SelectTree from '../../../components/vard-select-tree/vard-select-tree';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';

export default {
  props: ['operateType', 'dataId'],
  components: {
    SelectTree,
  },
  data() {
    var inputNumber = (rule, value, callback) => {
      if ((typeof value !== 'number' && isNaN(value)) || value < 0) {
        callback(new Error('有效数字数字！'));
      } else {
        callback();
      }
    };
    return {
      offsetNumFlag: false,
      addtionFeeItemFlag: false,
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          feeType: '',
          priceSet: '',
        },
      ],
      form: {
        offsetNum: '',
        offsetMoney: '',
        feeCycle: 3,
        feeCycleName: '月',
        feeCycleNum: 1,
        priceSet: '',
        delayDays: 0,
        stepPrices: [],
        propertyId: '',
        unitPrice: 0,
        cycleFlag: 1,
        objectTypeName: '',
        sortType: null,
        stopTime: null,
        useTime: null,
        billStartDate: null,
        remindDays: 3,
        msgDays: 1,
        delayRate: 0,
        remark1: '',
        feeItemsetSubs:[
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          feeType: '',
          priceSet: '',
        },
      ]
      },
      cycleFlagBool: false,
      unitPriceName: '单位价格(元)',
      objectTypeList: [],
      propertyTreeList: [],
      priceSetList: [],
      props: {
        value: 'id',
        label: 'title',
        children: 'children',
        // disabled:true
      },
      ////
      propertyName: '',
      treeProps: {
        //标题
        label: 'objectFullName',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      ////
      optionValue: '',
      feeSortList: [],
      allSortTypeList: [],
      enableSortTypeList: [],
      enableSortTypeAddtionList: [],
      feeTypeList: [],
      billSplitList: [],
      feeCycleList: [],
      feeCycleNameDisable: true,
      cycleFlagDictData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      editDisable1: false, //针对不可编辑以外的属性
      editDisable2: false, //针对不可编辑属性： 如 费用种类，费项编码
      gradePriceDisable: true,
      gradePriceShow: false, //阶梯价格显示
      switchValue: { yes: 1, no: 0 },
      rules: {
        // objectTypeName: [{ required: true, message: '请选择费项范围', trigger: 'blur' }],
        //objectTypeId: [{ required: true, message: '请选择费项范围', trigger: 'change' }],
        objectTypeName: [{ required: true, message: '请选择费项范围', trigger: 'blur' }],
        propertyId: [{ required: true, message: '请选择房产', trigger: 'change' }],
        feeSort: [{ required: true, message: '请选择费用种类', trigger: 'change' }],
        sortType: [{ required: true, message: '请选择费用细分', trigger: 'change' }],
        feeItemCode: [{ required: true, message: '请输入费项编码', trigger: 'blur' }],
        feeItemName: [{ required: true, message: '请输入费项名称', trigger: 'blur' }],
        feeType: [{ required: true, message: '请选择计费方式', trigger: 'change' }],
        feeCycle: [{ required: true, message: '请选择周期名称', trigger: 'change' }],
        feeCycleNum: [
          { required: true, message: '请输入周期数', trigger: 'blur' },
          { type: 'number', message: '周期数必须为大于1的数字值', min: 1, trigger: 'blur' },
        ],
        //feeCycleName: [{ required: true, message: '请输入自定义周期名称', trigger: 'change' }],
        cycleFlag: [{ required: true, message: '请选择是否周期收费', trigger: 'change' }],
        remindDays: [
          { required: true, message: '请输入提前提醒天数', trigger: 'blur' },
          { type: 'number', message: '提醒天数必须为数字值' },
        ],
        billStartDate: [{ required: true, message: '请选择开始收费日期', trigger: 'change' }],
        useTime: [
          { required: true, message: '请选择启用日期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              var dateStart = Date.parse(value);
              var dateEnd = Date.parse(this.form.stopTime);
              var dateNow = new Date().getTime();
              if (dateStart >= dateEnd) {
                callback(new Error('启用日期必须小于停用日期！'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        stopTime: [
          {
            required: true,
            message: '请选择停用日期',
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              var dateStart = Date.parse(this.form.useTime);
              var dateEnd = Date.parse(value);
              var dateNow = new Date().getTime();
              if (dateStart >= dateEnd) {
                callback(new Error('停用日期必须大于启用日期！'));
              } else if (dateNow >= dateEnd) {
                callback(new Error('启用日期必须大于当前日期！'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        msgDays: [
          { required: true, message: '请输入逾期催收天数', trigger: 'blur' },
          { type: 'number', message: '逾期催收天数必须为数字值' },
        ],
        delayRate: [{ required: true, message: '请输入滞纳金比率', trigger: 'blur' }],
        priceSet: [{ required: true, message: '计价类型必选', trigger: 'change' }],
        unitPrice: [
          { required: true, message: '请输入单位价格', trigger: 'blur' },
          {
            validator: inputNumber,
            trigger: 'blur',
          },
        ],
        delayDays: [
          { required: true, message: '请输入超期天数', trigger: 'blur' },
          { type: 'number', message: '超期天数必须为数字', min: 0, trigger: 'blur' },
        ],
        /*stepPrice: [
          { required: true, message: '请输入阶梯价格', trigger: 'blur' },
          { type: 'number', message: '阶梯价格必须为大于1的数字', min: 1 },
        ],*/
      },
    };
  },
  created() {},
  mounted() {
    this.initAllSelectList();
    if (['edit', 'view', 'copy'].includes(this.operateType)) {
      getDetail({ id: this.dataId }).then(({ data }) => {
        data.priceSet = data.priceSet + '';
        this.form = data;
        this.form.extraFlag = data.extraFlag + '';
        this.form.offsetFlag = data.offsetFlag + '';
        this.feeTypeChanged(this.form.feeType);
        this.propertyName = data.remark3;
        this.tableData = data.feeItemsetSubs;
        this.form.feeItemsetSubs = data.feeItemsetSubs;
        if (this.operateType === 'edit') {
          this.editDisable2 = true;
          this.cycleFlagBool = true;
        } else if (this.operateType === 'view') {
          this.editDisable1 = true;
          this.cycleFlagBool = true;
          this.editDisable2 = true;
          this.cycleFlagBool = true;
          this.gradePriceDisable = true;
        } else if (this.operateType === 'copy') {
          this.form.billStartDate = this.getNewDate();
          this.form.useTime = this.getNewDate();
          this.form.stopTime = this.getNewDate(2099);
          delete this.form.id;
        }
        if (this.form.priceSet === '3') {
          this.gradePriceShow = true;
        } else {
          this.gradePriceShow = false;
          if (this.form.priceSet === '2') {
            this.unitPriceName = '包干价(元)';
          } else {
            this.unitPriceName = '单位价格(元)';
          }
        }
      });
    } else if (this.operateType === 'add') {
      this.form.billStartDate = this.getNewDate();
      this.form.useTime = this.getNewDate();
      this.form.stopTime = this.getNewDate(2099);
      this.form.bankFlag = 1;
      this.form.preferentFlag = 1;
    }
  },

  methods: {
    // offsetNumChange(val){
    //   this.form.offsetNum = val;
    //   this.form = _.cloneDeep(this.form);
    // },
    addtionFeeItemChange(val) {
      console.log('addtionFeeItemChange=====================>', val);
      this.tableData = [];
      this.form.feeItemsetSubs = [];
      this.form = _.cloneDeep(this.form);
    },
    offsetNumChange(val) {
      console.log('offsetNumChange=====================>', val);
      if(!val){
        this.form.offsetMoney = '';
      }
    },
    deleteItemHandler(scope) {
      console.log('deleteItemHandler===========>', scope);
      this.tableData.splice(scope.$index, 1);
      this.form.feeItemsetSubs.splice(scope.$index, 1);
      this.form = _.cloneDeep(this.form);
    },
    addItemHandler() {
      this.tableData.push({});
      this.form.feeItemsetSubs.push({});
      this.form = _.cloneDeep(this.form);
    },
    getNewDate(year) {
      let dateToday = new Date();
      let yyyy = dateToday.getFullYear();
      if (year) {
        yyyy = year;
      }
      let mm = dateToday.getMonth() + 1;
      if (mm < 10) {
        mm = '0' + mm;
      }
      let dd = dateToday.getDate();
      if (dd < 10) {
        dd = '0' + dd;
      }
      // return yyyy + '-' + mm + '-' + dd + 'T00:00:00';
      return yyyy + '-' + mm + '-' + dd + ' 00:00:00';
    },
    changeCycleFlag(value) {
      console.log(value);
      console.log(value === 1);
      if (value === 0) {
        this.form.feeCycle = 9;
        this.form.feeCycleName = '非周期';
        this.cycleFlagBool = true;
      } else {
        this.cycleFlagBool = false;
      }
    },
    validateForm(fieldNmae) {
      this.$refs.form.validateField(fieldNmae);
    },
    initAllSelectList: function () {
      this.initObjectTypeList();
      this.initFeeSortList();
      this.initFeeTypeList();
      this.initFeeCycleList();
      this.initSortTypeList();
      this.getPriceSetList();
      this.getBillSplitList();
    },
    clearData: function () {
      this.form = {
        feeCycleName: '',
        priceSet: '',
        stepPrices: [],
        unitPrice: 0,
        delayDays: 0,
        propertyId: '',
        objectTypeName: '',
      };
      this.unitPriceName = '单位价格(元)';
      this.feeCycleNameDisable = true;
      this.gradePriceDisable = true;
    },
    priceSetChanged: function (value) {
      console.log('-----------' + value);
      if (value === '1') {
        this.unitPriceName = '单位价格(元)';
        this.gradePriceShow = false;
      } else if (value === '2') {
        this.unitPriceName = '包干价(元)';
        this.gradePriceShow = false;
      } else {
        this.gradePriceShow = true;
      }
    },
    priceSet_grade: function () {
      this.gradePriceDisable = false;
      this.gradePriceDisable = this.operateType === 'view';
      //this.gradePriceShow = true;
      if (this.form.stepPrices.length === 0) {
        this.form.stepPrices = [
          {
            stepMin: 0,
            stepMax: 10,
            stepPrice: 0,
            stepIndex: 0,
          },
        ];
      }
    },
    priceSet_grade_disable: function () {
      this.gradePriceDisable = true;
      this.gradePriceShow = false;
      if (this.operateType === 'add' || this.form.priceSet === '2') {
        this.form.priceSet = '2';
        this.unitPriceName = '包干价(元)';
      } else {
        this.unitPriceName = '单位价格(元)';
      }
    },
    feeCycleChanged: function (value) {
      if (value === 9) {
        this.feeCycleNameDisable = false;
        this.form.feeCycleName = '';
      } else {
        this.feeCycleList.forEach((e) => {
          if (e.dictKey === value) {
            this.form.feeCycleName = e.dictValue;
          }
        });
        this.feeCycleNameDisable = true;
      }
    },
    initFeeCycleList: function () {
      getDictionaryWithIntKey('fee_cycle').then((data) => {
        this.feeCycleList = data.data;
      });
    },
    getPriceSetList: function () {
      getDictionaryWithIntKey('price_set').then((data) => {
        this.priceSetList = data.data;
      });
    },
    getBillSplitList: function () {
      getDictionaryWithIntKey('bill_split').then((data) => {
        this.billSplitList = data.data;
      });
    },
    initSortTypeList: function () {
      getDictionaryWithIntKey('sort_type').then((data) => {
        this.allSortTypeList = data.data;
        this.enableSortTypeList = data.data;
        this.enableSortTypeAddtionList = data.data;
        this.enableSortTypeAddtionList = this.allSortTypeList.filter(function (s) {
          let str = s.dictKey+'';
        let index = str.search(/\d/);
        let charNum = str.charAt(index);
          return charNum == 4;
        });
      });
    },
    feeSortChanged: function (value) {
      console.log('----------' + JSON.stringify(this.allSortTypeList));
      this.enableSortTypeList = this.allSortTypeList.filter(function (s) {
        console.log(s.dictKey,value)
        let str = s.dictKey+'';
        let index = str.search(/\d/);
        let charNum = str.charAt(index);
        return charNum == value;
      });
      if (value !== 3) {
        this.cycleFlagDictData[1].disabled = true;
        this.form.cycleFlag = 1;
      } else {
        this.cycleFlagDictData[1].disabled = false;
      }
      console.log(JSON.stringify(this.enableSortTypeList));
      this.changeCycleFlag(1);
      this.form.sortType = null;
    },
    feeTypeChanged: function (value) {
      if (7 <= value && value <= 10) {
        this.priceSet_grade(); // 梯形票价可用
      } else {
        this.priceSet_grade_disable();
      }
    },
    initFeeTypeList: function () {
      getDictionaryWithIntKey('fee_type').then((data) => {
        this.feeTypeList = data.data;
      });
    },
    initFeeSortList: function () {
      getDictionaryWithIntKey('fee_sort').then((data) => {
        this.feeSortList = data.data.filter((ele) => {
          return ele.dictKey !== 2 && ele.dictKey !== 6 && ele.dictKey !== 7 && ele.dictKey !== 8;
        });
      });
    },
    ////////////
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        //this.isPropertyAddDialogInit = true;
        //this.propertyAddParentNodeTreeRoot = node;
        //this.propertyAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenPowerNode({ id: id, power: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    propertyNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      this.propertyName = nodeTitle;
      this.form.propertyId = nodeId;
      this.form.objectTypeName = nodeTypeName;
      this.form.objectType = node['objectType'];
      this.form.remark3 = nodeTitle;

      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
        //this.propertyAddForm.parentId = nodeId;
        //this.propertyAddForm.parentObjectTypeName = nodeTypeName;
      }
    },
    ///////////////
    onPropertySelected: function (value) {
      if (value == null) {
      } else {
        var node = this.getTreeNode(value, this.propertyTreeList);
        if (node == null || node.objectType !== this.form.objectTypeId) {
          this.form.propertyId = '';
          this.$refs.selectTree.valueTitle = '';
          //this.$refs.selectTree.clearHandle();
        } else {
          this.form.propertyId = value;
          this.$refs.selectTree.valueTitle = node.title;
        }
      }
    },
    getTreeNode: function (id, nodes) {
      var res;
      for (var i in nodes) {
        var node = nodes[i];
        if (node.id === id) {
          res = node;
        } else if (node.children) {
          var childFind = this.getTreeNode(id, node.children);
          if (typeof childFind !== 'undefined') {
            res = childFind;
          }
        }
      }
      return res;
    },
    objectTypeIdChanged: function (value) {
      if (value) {
        getLabelName({ code: 'object_type', key: value }).then(({ data }) => {
          this.form.objectType = data;
        });
        getPropertyTreeByObjectTypeKey(value).then((data) => {
          //this.$refs.selectTree.clearHandle();
          this.propertyTreeList = data.data;
          //this.casecadeUpdateProperty();
        });
      }
    },
    casecadeUpdateProperty: function () {
      if (this.form.propertyId) {
        this.onPropertySelected(this.form.propertyId);
      }
    },
    initObjectTypeList: function () {
      getDictionaryWithIntKey('object_type').then((data) => {
        this.objectTypeList = data.data;
      });
    },
    addStepPrice: function (stepPrice) {
      const stepIndex = this.form.stepPrices.length;
      let lastStepPrice = this.form.stepPrices[stepIndex - 1];
      if (lastStepPrice.stepMax <= lastStepPrice.stepMin) {
        this.$message.error('后面使用量必须大于前面！');
        return;
      }
      let newStepPrice = {
        stepMin: stepPrice.stepMax,
        stepMax: stepPrice.stepMax + 100000,
        stepPrice: 0,
        stepIndex: stepIndex,
      };
      this.form.stepPrices.push(newStepPrice);
    },
    removeStepPrice: function (index) {
      if (index === 0) {
        this.$message.info('至少保留一个！');
      } else {
        this.form.stepPrices.splice(index, 1);
      }
    },
    closeDia: function (refresh) {
      this.$emit('closeAeform', refresh);
    },
    checkFormDataCorrect: function () {
      // 检查数据合法性
      if (this.form.priceSet === '3') {
        const stepIndex = this.form.stepPrices.length;
        let lastStepPrice = this.form.stepPrices[stepIndex - 1];
        if (lastStepPrice.stepMax < 10000000) {
          this.form.stepPrices[stepIndex - 1].stepMax = 10000000;
        }
        if (lastStepPrice.stepMax <= lastStepPrice.stepMin) {
          this.$message.error('最后一个阶梯使用量填写不合法！');
          return false;
        }
      }
      var dateStart = Date.parse(this.form.useTime);
      var dateEnd = Date.parse(this.form.stopTime);
      var dateNow = new Date().getTime();
      if (dateNow > dateStart && dateNow < dateEnd) {
        this.form.validFlag = 1;
      } else {
        this.form.validFlag = 0;
      }
      return true;
    },
    appendSuffix(datetime) {
      if (datetime && datetime.length < 12) {
        return datetime + 'T00:00:00';
      } else {
        return datetime;
      }
    },
    onSubmit() {
      // this.form.feeItemsetSubs = _.cloneDeep(this.tableData);

      console.log(JSON.stringify(this.form));
      this.$refs.form.validate((valid) => {
        if (valid && this.checkFormDataCorrect()) {
          add(this.form).then(() => {
            this.$message.success('操作成功!');
            //this.clearData();
            this.closeDia('refresh');
          });
        } else {
          this.$message.warning('数据不合法！');
        }
      });
      /* .then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        error => {
          done();
          console.log(error);
        }
      );*/
    },
  },
};
</script>
<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding-left: 10px;
  line-height: 25px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
